import Picker from '../picker';
import Panel from '../panel/time-select';

export default {
  mixins: [Picker],

  name: 'YjTimeSelect',

  componentName: 'YjTimeSelect',

  props: {
    type: {
      type: String,
      default: 'time-select'
    }
  },

  beforeCreate() {
    this.panel = Panel;
  }
};



// WEBPACK FOOTER //
// ./src/components/date-picker/src/picker/time-select.js